import script from "./InputRangeItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputRangeItem.vue?vue&type=script&setup=true&lang=ts"

import "./InputRangeItem.vue?vue&type=style&index=0&id=e4578c8e&lang=css"

const __exports__ = script;

export default __exports__